// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"H8-z"};